import styled from "styled-components";

import Box from "../../../components/Box";
import LabeledInput from "../../../components/LabeledInput";
import LabeledSwitch from "../../../components/LabeledSwitch";

const Styled = styled(Box)`
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-template-rows: repeat(3, min-content);
    grid-auto-flow: column;

    @media (max-width: 720px) {
        grid-template-columns: 1fr;
        grid-template-rows: repeat(5, min-content);
    }
`;

export default function SharedParameterAttributes(props) {
    return (
        <Styled name="attributes">
            <BooleanSwitch
                label="binding"
                onChange={ props.setInstance }
                options={ ["instance", "type"] }
                value={ props.instance }
            />
            <BooleanSwitch
                label="modifiability"
                onChange={ props.setModifiable }
                options={ ["modifiable", "non-modifiable"] }
                value={ props.modifiable }
            />
            <BooleanSwitch
                label="visibility"
                onChange={ props.setVisible }
                options={ ["visible", "hidden"] }
                value={ props.visible }
            />
            <LabeledInput
                label="display group"
                onChange={ props.setGroup }
                value={ props.group }
            />
            <LabeledInput
                label="type"
                onChange={ props.setType }
                value={ props.type }
            />
        </Styled>
    );
}

function BooleanSwitch(props) {
    return (
        <LabeledSwitch
            { ...props }
            onChange={ props.onChange ?? (() => {}) }
            options={
                [
                    { label: props.options[0], value: true },
                    { label: props.options[1], value: false },
                ].filter(
                    (option) => props.onChange || option.value === props.value
                )
            }
        />
    );
}
